class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.handleEscape = (event) => {
      if (event.key === 'Escape' || event.code === 'Escape') {
        this.close();
      }
    };

    this.handleOverlayClick = () => {
      this.close();
    };

    this.addEventListener('keyup', this.handleEscape);

    this.setupOverlay();

    this.setHeaderCartIconAccessibility();

    /*
     * Synchronisation du nombre d'articles
     * avec toutes les zones affichant le panier.
     */
    this.updateCartCount();

    /*
     * Surveille les modifications du panier Shopify.
     */
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });

    document.addEventListener('cartUpdate', () => {
      this.updateCartCount();
    });

    /*
     * Certains thèmes Shopify utilisent PUB_SUB_EVENTS.
     */
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.updateCartCount();
        });
      } catch (error) {
        console.log('Cart update listener:', error);
      }
    }

    /*
     * Synchronisation régulière de sécurité.
     * Cela permet notamment de mettre à jour la barre
     * panier fixe personnalisée.
     */
    this.cartCountInterval = setInterval(() => {
      this.updateCartCount();
    }, 1500);
  }


  /*
   * ---------------------------------------------------------
   * OVERLAY
   * ---------------------------------------------------------
   */

  setupOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (!overlay) return;

    overlay.removeEventListener(
      'click',
      this.handleOverlayClick
    );

    overlay.addEventListener(
      'click',
      this.handleOverlayClick
    );

    overlay.removeEventListener(
      'touchend',
      this.handleOverlayClick
    );

    overlay.addEventListener(
      'touchend',
      this.handleOverlayClick,
      {
        passive: true
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * ICONE PANIER HEADER
   * ---------------------------------------------------------
   */

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute(
      'role',
      'button'
    );

    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    /*
     * On évite de créer plusieurs listeners.
     */
    if (
      cartLink.dataset.cartDrawerListener === 'true'
    ) {
      return;
    }

    cartLink.dataset.cartDrawerListener = 'true';

    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.open(cartLink);
      }
    );

    cartLink.addEventListener(
      'touchend',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.open(cartLink);
      },
      {
        passive: false
      }
    );

    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.code === 'Space'
        ) {
          event.preventDefault();

          this.open(cartLink);
        }
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * OUVERTURE DU PANIER
   * ---------------------------------------------------------
   */

  async open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const drawer =
      this.querySelector('.drawer__inner');

    if (!drawer) return;

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }

    /*
     * -------------------------------------------------------
     * VERIFICATION DU VRAI ETAT DU PANIER
     * -------------------------------------------------------
     *
     * C'est cette partie qui règle le problème.
     *
     * Lorsque l'utilisateur arrive sur le site avec
     * un panier déjà vide et clique directement sur
     * l'icône panier, on vérifie immédiatement cart.js.
     *
     * 0 article :
     *      cart-drawer possède la classe is-empty
     *
     * article(s) :
     *      cart-drawer ne possède pas is-empty
     *
     * Cela permet au design personnalisé du panier vide
     * de s'afficher dès la première ouverture.
     */

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js?drawer_open=${Date.now()}`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          cache: 'no-store'
        }
      );

      if (response.ok) {
        const cart = await response.json();

        const itemCount =
          Number(cart.item_count) || 0;

        /*
         * IMPORTANT :
         * on met à jour la classe du cart-drawer
         * avant l'ouverture visuelle.
         */
        this.classList.toggle(
          'is-empty',
          itemCount === 0
        );

        /*
         * On synchronise également le compteur.
         */
        this.updateCartCount();
      }
    } catch (error) {
      console.log(
        'Impossible de vérifier le panier à l’ouverture :',
        error
      );
    }


    /*
     * On ferme la notification
     * "Article ajouté au panier".
     */
    const cartNotification =
      document.querySelector(
        'cart-notification'
      );

    if (cartNotification) {
      cartNotification.classList.remove(
        'active',
        'animate'
      );

      cartNotification.style.display =
        'none';
    }


    /*
     * IMPORTANT :
     *
     * On ne fait PLUS :
     *
     * this.classList.remove('is-empty');
     *
     * car cette ligne supprimait le design du
     * panier vide lors de la première ouverture.
     */


    /*
     * Animation.
     */
    requestAnimationFrame(() => {
      this.classList.add('animate');
      this.classList.add('active');
    });


    document.body.classList.add(
      'overflow-hidden'
    );


    this.setupOverlay();


    /*
     * Focus clavier.
     */
    const focusContainer =
      this.querySelector(
        '.drawer__inner'
      );

    const focusElement =
      this.querySelector(
        '.drawer__close'
      ) ||
      this.querySelector(
        'button, a, input'
      );

    if (
      focusContainer &&
      focusElement
    ) {
      setTimeout(() => {
        try {
          if (
            typeof trapFocus ===
            'function'
          ) {
            trapFocus(
              focusContainer,
              focusElement
            );
          } else {
            focusElement.focus();
          }
        } catch (error) {
          try {
            focusElement.focus();
          } catch (e) {}
        }
      }, 150);
    }


    /*
     * Événement Shopify.
     */
    const cartItems =
      this.querySelector(
        'cart-drawer-items'
      );

    if (
      cartItems &&
      typeof cartItems.dispatchViewEvent ===
        'function'
    ) {
      cartItems.dispatchViewEvent();
    }


    /*
     * Mise à jour finale du compteur.
     */
    this.updateCartCount();
  }


  /*
   * ---------------------------------------------------------
   * FERMETURE
   * ---------------------------------------------------------
   */

  close() {
    this.classList.remove(
      'active'
    );

    this.classList.remove(
      'animate'
    );

    document.body.classList.remove(
      'overflow-hidden'
    );

    if (this.activeElement) {
      try {
        if (
          typeof removeTrapFocus ===
          'function'
        ) {
          removeTrapFocus(
            this.activeElement
          );
        }
      } catch (error) {
        try {
          this.activeElement.focus();
        } catch (e) {}
      }
    }

    this.setupOverlay();
  }


  /*
   * ---------------------------------------------------------
   * ACCESSIBILITE DETAILS
   * ---------------------------------------------------------
   */

  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute(
        'id'
      )
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }


    /*
     * Évite plusieurs listeners.
     */
    if (
      cartDrawerNote.dataset
        .accessibilityReady ===
      'true'
    ) {
      return;
    }

    cartDrawerNote.dataset
      .accessibilityReady =
      'true';


    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        const details =
          event.currentTarget.closest(
            'details'
          );

        if (!details) return;

        event.currentTarget.setAttribute(
          'aria-expanded',
          !details.hasAttribute('open')
        );
      }
    );


    if (
      cartDrawerNote.parentElement &&
      typeof onKeyUpEscape ===
        'function'
    ) {
      cartDrawerNote.parentElement.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }
  }


  /*
   * ---------------------------------------------------------
   * RAFRAICHISSEMENT DU PANIER
   * ---------------------------------------------------------
   */

  renderContents(
    parsedState
  ) {
    const drawerInner =
      this.querySelector(
        '.drawer__inner'
      );

    if (!drawerInner) return;


    if (
      drawerInner.classList.contains(
        'is-empty'
      )
    ) {
      drawerInner.classList.remove(
        'is-empty'
      );
    }


    this.classList.remove(
      'is-empty'
    );


    this.productId =
      parsedState.id;


    /*
     * Mise à jour des sections Shopify.
     */
    this.getSectionsToRender()
      .forEach((section) => {

        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );

        if (!sectionElement) return;


        const html =
          parsedState.sections &&
          parsedState.sections[
            section.id
          ];

        if (!html) return;


        sectionElement.innerHTML =
          this.getSectionInnerHTML(
            html,
            section.selector
          );
      });


    /*
     * Après reconstruction du panier,
     * on remet tous les événements.
     */
    setTimeout(() => {

      this.setupOverlay();

      this.setHeaderCartIconAccessibility();

      /*
       * open() vérifie maintenant le vrai
       * nombre d'articles dans cart.js.
       */
      this.open();


      /*
       * Synchronisation immédiate du compteur.
       */
      this.updateCartCount();


      /*
       * Petit délai supplémentaire car Shopify
       * peut terminer le remplacement du DOM.
       */
      setTimeout(() => {
        this.updateCartCount();
      }, 100);


      setTimeout(() => {
        this.updateCartCount();
      }, 500);

    }, 50);
  }


  /*
   * ---------------------------------------------------------
   * SECTIONS SHOPIFY
   * ---------------------------------------------------------
   */

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const documentHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      documentHTML.querySelector(
        selector
      );

    return element
      ? element.innerHTML
      : '';
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }


  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      );
  }


  setActiveElement(
    element
  ) {
    this.activeElement =
      element;
  }


  /*
   * ---------------------------------------------------------
   * COMPTEUR PANIER
   * ---------------------------------------------------------
   *
   * C'EST CETTE PARTIE QUI CORRIGE :
   *
   * Panier (0)
   *
   * alors que le panier contient des articles.
   */

  async updateCartCount() {
    try {

      const response =
        await fetch(
          `${window.Shopify.routes.root}cart.js?timestamp=${Date.now()}`,
          {
            method: 'GET',
            headers: {
              'Accept':
                'application/json'
            },
            cache: 'no-store'
          }
        );


      if (!response.ok) return;


      const cart =
        await response.json();


      const count =
        Number(
          cart.item_count
        ) || 0;


      /*
       * -----------------------------------------------------
       * 1. Compteur Shopify classique
       * -----------------------------------------------------
       */

      const standardCounters =
        document.querySelectorAll(
          '.cart-count-bubble, ' +
          '[data-cart-count], ' +
          '[data-cart-item-count], ' +
          '.cart-count'
        );


      standardCounters.forEach(
        (element) => {

          /*
           * Compteur numérique.
           */
          const numberElements =
            element.querySelectorAll(
              'span, .cart-count-number'
            );


          if (
            numberElements.length >
            0
          ) {

            numberElements.forEach(
              (numberElement) => {

                const text =
                  numberElement
                    .textContent
                    .trim();


                if (
                  /^\d+$/.test(
                    text
                  )
                ) {
                  numberElement.textContent =
                    count;
                }

              }
            );

          } else {

            /*
             * Si l'élément contient seulement
             * un nombre.
             */
            if (
              /^\d+$/.test(
                element.textContent.trim()
              )
            ) {
              element.textContent =
                count;
            }

          }


          /*
           * Accessibilité.
           */
          element.setAttribute(
            'aria-label',
            `${count} article${
              count > 1
                ? 's'
                : ''
            } dans le panier`
          );
        }
      );


      /*
       * -----------------------------------------------------
       * 2. Barre panier fixe personnalisée
       * -----------------------------------------------------
       *
       * Cherche les textes :
       *
       * Panier (0)
       * Panier (1)
       * Panier (2)
       * etc.
       *
       * et remplace uniquement le nombre.
       */

      const allElements =
        document.querySelectorAll(
          'body *'
        );


      allElements.forEach(
        (element) => {

          /*
           * On ignore les gros conteneurs
           * pour éviter de modifier toute une zone.
           */
          if (
            element.children.length >
            10
          ) {
            return;
          }


          /*
           * Seulement les éléments qui
           * contiennent "Panier (nombre)".
           */
          const text =
            element.textContent.trim();


          const match =
            text.match(
              /^Panier\s*\(\s*\d+\s*\)$/
            );


          if (!match) return;


          /*
           * Remplacement du nombre.
           */
          element.textContent =
            `Panier (${count})`;


          /*
           * Accessibilité.
           */
          element.setAttribute(
            'aria-label',
            `Panier (${count})`
          );
        }
      );


      /*
       * -----------------------------------------------------
       * 3. Mise à jour des attributs courants
       * -----------------------------------------------------
       */

      document
        .querySelectorAll(
          '[data-count]'
        )
        .forEach(
          (element) => {

            element.setAttribute(
              'data-count',
              count
            );

          }
        );


      /*
       * -----------------------------------------------------
       * 4. EVENEMENT GLOBAL
       * -----------------------------------------------------
       */

      document.dispatchEvent(
        new CustomEvent(
          'cart-count-updated',
          {
            detail: {
              count: count,
              cart: cart
            }
          }
        )
      );


    } catch (error) {

      console.error(
        'Erreur synchronisation compteur panier:',
        error
      );

    }
  }
}


/*
 * ---------------------------------------------------------
 * CUSTOM ELEMENT CART DRAWER
 * ---------------------------------------------------------
 */

if (
  !customElements.get(
    'cart-drawer'
  )
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}


/*
 * ---------------------------------------------------------
 * CART DRAWER ITEMS
 * ---------------------------------------------------------
 */

class CartDrawerItems
  extends CartItems {

  getSectionsToRender() {

    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector:
          '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section:
          'cart-icon-bubble',
        selector:
          '.shopify-section'
      }
    ];

  }
}


if (
  !customElements.get(
    'cart-drawer-items'
  )
) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}


/*
 * ---------------------------------------------------------
 * SYNCHRONISATION INITIALE
 * ---------------------------------------------------------
 */

document.addEventListener(
  'DOMContentLoaded',
  () => {

    const drawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      drawer &&
      typeof drawer.updateCartCount ===
        'function'
    ) {

      drawer.updateCartCount();

    }

  }
);